/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Box } from 'native-base';

import { RewardGrant, useAppSettings } from '@springbig/shared';
import RewardGrantCard, { RewardGrantCardSkeleton } from '~/shared/RewardGrantCard';

type OffersCardProps = {
    rewardGrants: RewardGrant[];
    handleAcceptRedeemReward: (id: number, title: string) => void;
    handleBonusRewards: (id: number) => void;
    rewardActiveId: number | undefined;
    loadingActivation: boolean;
};

const OffersCard: React.FC<OffersCardProps> = ({
    rewardGrants,
    handleAcceptRedeemReward,
    handleBonusRewards,
    loadingActivation,
    rewardActiveId,
}) => {
    const { hasCustomBackground } = useAppSettings();

    if (!rewardGrants || rewardGrants.length === 0) {
        return null;
    }

    return (
        <Box w="100%" mb={2} pb={hasCustomBackground ? 32 : 0}>
            {rewardGrants.map((offer, index) => (
                <RewardGrantCard
                    key={offer.id}
                    offer={offer}
                    handleAcceptRedeemReward={handleAcceptRedeemReward}
                    handleBonusRewards={handleBonusRewards}
                    rewardActiveId={rewardActiveId}
                    loadingActivation={loadingActivation}
                />
            ))}
        </Box>
    );
};

export const OffersCardSkeleton = () => Array.from({ length: 10 }, (_, index) => (
    <RewardGrantCardSkeleton />
));

export default OffersCard;
